import {createReducer, on} from '@ngrx/store';
import {datevWizardExportDateStateInitial} from './datev-wizard-export-date.state.initial';
import {DatevWizardExportDateActions} from './datev-wizard-export-date.actions';


export const datevWizardExportDateReducers = createReducer(
  datevWizardExportDateStateInitial,

  on(
    DatevWizardExportDateActions.setExportDate,
    (state, {exportDate}) => ({
      ...state,
      exportDate,
      exportDateIndependent: undefined,
    }),
  ),

  on(
    DatevWizardExportDateActions.setExportDateIndependent,
    (state, {exportDateIndependent}) => ({
      ...state,
      exportDateIndependent,
      exportDate: undefined,
    }),
  ),

  on(
    DatevWizardExportDateActions.resetExportDate,
    () => ({
      ...datevWizardExportDateStateInitial,
    }),
  ),
);
